import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allIntermediaries: [],
    loading: false,
    error: null,
};

const intermediarySlice = createSlice({
    name: 'intermediary',
    initialState,
    reducers: {
        setAllIntermediaries: (state, action) => {
            state.allIntermediaries = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item, no: index + 1 })) : [];
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllIntermediaries } = intermediarySlice.actions;

export default intermediarySlice.reducer;